export default "__VITE_ASSET__2f7ef97c__"